import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mounts once at the app root and fires a GA4 `page_view` event on every
 * React Router navigation. Without this, single-page-app route changes are
 * invisible to Google Analytics — only the first page load is counted.
 *
 * No-ops silently when:
 *   • REACT_APP_GA_ID is not configured
 *   • The user has not yet granted analytics consent (window.gtag absent)
 *
 * GA4 is loaded lazily by CookieConsent.jsx after consent, so this hook
 * piggybacks on whatever `window.gtag` is available at the time of nav.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    if (!gaId || gaId === "G-XXXXXXXXXX") return;
    if (typeof window.gtag !== "function") return;

    const pagePath = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
      send_to: gaId,
    });
  }, [location.pathname, location.search]);

  return null;
}
